/**
 * Recursively removes undefined values, NaN, and functions from an object
 * to ensure Firestore compatibility
 */
export function sanitizeData<T>(data: T): T {
  if (data === null || data === undefined) {
    return null as any;
  }

  if (typeof data === 'number' && isNaN(data)) {
    return null as any;
  }

  if (typeof data === 'function') {
    return null as any;
  }

  if (data instanceof Date) {
    return data;
  }

  if (Array.isArray(data)) {
    return data.map(item => sanitizeData(item)).filter(item => item !== null && item !== undefined) as any;
  }

  if (typeof data === 'object') {
    const sanitized: any = {};
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        const value = sanitizeData(data[key]);
        if (value !== undefined && value !== null) {
          sanitized[key] = value;
        }
      }
    }
    return sanitized;
  }

  return data;
}
